import { Autocomplete, AutocompleteChangeReason, TextField } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CorporateEssential } from '../../../store/actions/corporates';
import { RootState } from '../../../store/reducers';

interface ICorporateAutoCompleteProps {
    filterCorporate: string | undefined;
    setFilterCorporate: (corporate: string | undefined) => void;
}
const CorporateAutoComplete = ({ filterCorporate, setFilterCorporate }: ICorporateAutoCompleteProps) => {
    const { t } = useTranslation();
    const corporatesState: CorporateEssential[] = useSelector((state: RootState) => state.corporatesUser.list);
    const [corporateListOptions, setCorporateListOptions] = useState<[] | { label: string; value: string }[]>([]);
    const [corporateOptionSelected, setCorporateOptionSelected] = useState<{ label: string; value: string } | null>(null);

    useEffect(() => {
        const arrayCorporatesOption: { label: string; value: string }[] = [];
        corporatesState?.map((corporate: CorporateEssential) => {
            arrayCorporatesOption.push({
                label: corporate.name,
                value: corporate.id
            });
            return arrayCorporatesOption;
        });

        setCorporateListOptions(arrayCorporatesOption);
    }, [corporatesState]);

    useEffect(() => {
        if (!filterCorporate) setCorporateOptionSelected(null);
        if (!corporatesState) return;
        const corporateElement: CorporateEssential | undefined = corporatesState?.find((corporate: CorporateEssential) => corporate.id === filterCorporate);

        setCorporateOptionSelected(
            corporateElement
                ? {
                      label: corporateElement.name,
                      value: corporateElement.id
                  }
                : null
        );
    }, [corporatesState, filterCorporate]);

    return (
        <Autocomplete
            disablePortal
            id="combo-box-corporates"
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={corporateOptionSelected}
            onInputChange={(event: SyntheticEvent<Element, Event>, value: string, reason: AutocompleteChangeReason) => {
                if (reason === 'clear') {
                    setFilterCorporate(undefined);
                    return;
                }
            }}
            inputValue={corporateOptionSelected?.label || ''}
            options={corporateListOptions}
            sx={{ width: '100%', minWidth: '140px' }}
            renderInput={(params) => <TextField {...params} label={t('corporate.label', { ns: 'common' })} InputLabelProps={{ shrink: true }} variant="standard" />}
            onChange={(event: SyntheticEvent<Element, Event>, value: { label: string; value: string } | null, _reason: AutocompleteChangeReason) => {
                setFilterCorporate(value?.value ?? undefined);
            }}
            placeholder={t('corporate.placeholder', { ns: 'common' })}
        />
    );
};

export default CorporateAutoComplete;
